import axiosInstance from ".";

export const fetchPartners = () =>
  axiosInstance.get(`/v1/partners`);

export const fetchPartner = (id) =>
  axiosInstance.get(`/v1/partners/${id}`);

// "Become a partner" application form (public "/Partners" page). Posts to
// the shared contact-form endpoint, tagged so it's distinguishable from
// generic lead/support submissions (see taurian-backend ContactFormType).
export const submitPartnerApplication = ({ name, email, phone, category, message }) =>
  axiosInstance.post(`/contact-form`, { name, email, phone, category, message, type: 'partner' });
